import React from 'react';
import { Briefcase, Users, Shield, CheckCircle, TrendingUp, UserCheck } from 'lucide-react';
import './ServicesPage.css';

const ServicesPage = () => {
  const services = [
    {
      icon: <Briefcase size={48} />,
      title: 'Consulting Services',
      description: 'Strategic guidance to transform your business operations and drive sustainable growth.',
      features: [
        'Business Strategy & Planning',
        'Operational Excellence',
        'Digital Transformation',
        'Change Management',
        'Performance Optimization',
        'Risk Assessment & Mitigation',
      ],
    },
    {
      icon: <Users size={48} />,
      title: 'Recruitment Solutions',
      description: 'Connect with exceptional talent that perfectly aligns with your company culture and goals.',
      features: [
        'Executive Search',
        'Permanent Placement',
        'Contract Staffing',
        'Talent Pipeline Development',
        'Skills Assessment',
        'Onboarding Support',
      ],
    },
    {
      icon: <Shield size={48} />,
      title: 'Background Check Services',
      description: 'Comprehensive verification and screening services to ensure safety and compliance.',
      features: [
        'Employment Verification',
        'Education Verification',
        'Criminal Background Checks',
        'Professional License Verification',
        'Reference Checks',
        'Identity Verification',
      ],
    },
  ];

  const process = [
    {
      icon: <UserCheck size={32} />,
      title: 'Consultation',
      description: 'We start by understanding your unique needs and challenges.',
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Strategy',
      description: 'Develop a tailored approach based on industry best practices.',
    },
    {
      icon: <CheckCircle size={32} />,
      title: 'Execution',
      description: 'Implement solutions with ongoing support and communication.',
    },
  ];

  return (
    <div className="services-page" data-testid="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="services-hero-content">
            <h1 data-testid="services-hero-title">Our Services</h1>
            <p data-testid="services-hero-subtitle">
              Comprehensive solutions designed to help your business thrive in today's competitive landscape.
            </p>
          </div>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="services-detail-section section">
        <div className="container">
          <div className="services-detail-grid">
            {services.map((service, index) => (
              <div key={index} className="service-detail-card" data-testid={`service-detail-${index}`}>
                <div className="service-detail-icon">{service.icon}</div>
                <h2 className="service-detail-title">{service.title}</h2>
                <p className="service-detail-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx}>
                      <CheckCircle size={20} />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" data-testid="process-title">Our Process</h2>
            <p className="section-subtitle">
              A proven approach that delivers consistent results
            </p>
          </div>
          <div className="process-grid">
            {process.map((step, index) => (
              <div key={index} className="process-card" data-testid={`process-${index}`}>
                <div className="process-number">{index + 1}</div>
                <div className="process-icon">{step.icon}</div>
                <h3 className="process-title">{step.title}</h3>
                <p className="process-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta-section">
        <div className="container">
          <div className="services-cta-content">
            <h2 data-testid="services-cta-title">Ready to Transform Your Business?</h2>
            <p>Contact us today to discuss how we can help you achieve your goals.</p>
            <div className="services-cta-buttons">
              <a href="/background-check" className="btn btn-accent btn-lg">Request Background Check</a>
              <a href="#contact" className="btn btn-secondary btn-lg">Contact Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
